import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 24BCD03F-8D84-4154-95F5-086230CE3BBA
 * name pandora
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pandora.svg
 * tags
 * - Brand / Logo 
 */
export const PandoraIcon = createSvgIcon(<><path d="M10,20A1,1 0 0,1 9,21H4V3H13.71A6.75,6.75 0 0,1 20.46,9.75C20.46,13.5 17.44,16.5 13.71,16.5H10V20Z" /></>, 'PandoraIcon');
export default PandoraIcon